import(/* webpackMode: "eager" */ "/app/src/app/(lyk-appp)/(sidebar)/earnings/page.tsx")